import { render, staticRenderFns } from "./GiftCardBlock.vue?vue&type=template&id=25662899&scoped=true"
import script from "./GiftCardBlock.vue?vue&type=script&lang=js"
export * from "./GiftCardBlock.vue?vue&type=script&lang=js"
import style0 from "./GiftCardBlock.vue?vue&type=style&index=0&id=25662899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25662899",
  null
  
)

export default component.exports